import PropTypes from 'prop-types';

const imageAttributeShape = {
  url: PropTypes.string.isRequired,
};

export default imageAttributeShape;
